import React from 'react';
import ChipWrapper from 'talent_matching/components/applied_filters/chip_wrapper';
import { useFormContext } from '@grnhse/seedling/lib/birch/components/forms/form';
import { useUserContext } from 'talent_matching/contexts/user_context';
import type AdvancedFilter from 'talent_matching/components/filters/advanced_filter';
import type { TalentMatchingFilters } from 'talent_matching/types';
import ClearableFilter from 'talent_matching/components/applied_filters/clearable_filter';

type Props = {
  filter: AdvancedFilter;
  fieldName?: 'advancedFilters' | 'questionFilters' | 'educationFilters';
};

const AppliedAdvancedFilterChip = ({
  filter,
  fieldName = 'advancedFilters',
}: Props) => {
  const { watch, setValue } = useFormContext<TalentMatchingFilters>();
  const { userDateFormat } = useUserContext();

  const activeFilters: AdvancedFilter[] =
    (watch(fieldName) as AdvancedFilter[]) || [];

  const onRemove = () => {
    const newFilters = activeFilters.filter(
      (f: AdvancedFilter) => f.reactKey !== filter.reactKey
    );
    setValue(fieldName, newFilters, { shouldDirty: true });
  };

  const text = filter.appliedFilterText(userDateFormat, {
    question: fieldName === 'questionFilters',
  });

  return (
    <ChipWrapper>
      <ClearableFilter text={text} onRemove={onRemove} />
    </ChipWrapper>
  );
};

export default AppliedAdvancedFilterChip;
